import { BNB } from '@jdiyield/constants'
import { AnotherToken, LendContract, Lending, PriceList, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import { findToken, makeBatchRequest } from '../utils'

const nativeBNB = '0x0000000000000000000000000000000000000000'
const venusLensAddress = '0x595e9DDfEbd47B54b996c839Ef3Dd97db3ED19bA'

export const getVenusLending = async (
  web3: Web3,
  walletAddress: string,
  lendContract: LendContract,
  tokens: Token[],
  priceList: PriceList
): Promise<Lending> => {
  try {
    const lendTokens = lendContract?.lendTokens || []
    const { VenusLens } = await import('@jdiyield/abi')
    const venusLensCt = new web3.eth.Contract(VenusLens as any, venusLensAddress)
    // const prices = await venusLensCt.methods.vTokenUnderlyingPriceAll(lendTokens).call()
    const lendInfos = await makeBatchRequest(
      web3,
      lendTokens.flatMap((vAddress) => {
        return [
          venusLensCt.methods.vTokenBalances(vAddress, walletAddress).call,
          venusLensCt.methods.vTokenMetadata(vAddress).call // for underlyingAddress and decimal
        ]
      })
    )
    const formatLendInfos = [...new Array(lendInfos.length / 2)].map((_, i) => {
      const index = i * 2
      const vTokenBalances = lendInfos[index]
      const vTokenMetadata = lendInfos[index + 1]
      const tokenInfo = findToken(
        tokens,
        vTokenMetadata['underlyingAssetAddress'] === nativeBNB ? BNB : vTokenMetadata['underlyingAssetAddress']
      )
      const collateralTokenAmount = new BigNumber(vTokenBalances['balanceOfUnderlying'])
      const decimals = tokenInfo?.decimals || +vTokenMetadata?.decimals || 18
      const collateralTokenValue = collateralTokenAmount.dividedBy(`1e${decimals}`).toNumber()
      const usdPerCoin =
        priceList[tokenInfo?.address || vTokenMetadata['underlyingAssetAddress'].toLowerCase()]?.usd ?? 0

      const collateralToken: AnotherToken = {
        logo: tokenInfo?.logo,
        name: tokenInfo?.name || '???',
        symbol: tokenInfo?.symbol || '???',
        decimals: decimals,
        address: tokenInfo?.address || vTokenMetadata['underlyingAssetAddress'].toLowerCase(),
        usdPerCoin,
        amount: collateralTokenAmount,
        value: collateralTokenValue,
        valueUSD: collateralTokenValue * usdPerCoin
      }

      const borrowTokenAmount = new BigNumber(vTokenBalances['borrowBalanceCurrent'])
      const borrowTokenValue = borrowTokenAmount.dividedBy(`1e${decimals}`).toNumber()

      const borrowToken: AnotherToken = {
        logo: tokenInfo?.logo,
        name: tokenInfo?.name || '???',
        symbol: tokenInfo?.symbol || '???',
        decimals: decimals,
        address: tokenInfo?.address || vTokenMetadata['underlyingAssetAddress'].toLowerCase(),
        usdPerCoin,
        amount: borrowTokenAmount,
        value: borrowTokenValue,
        valueUSD: borrowTokenValue * usdPerCoin
      }
      return {
        collateralToken,
        borrowToken
      }
    })
    const supplyBalance = formatLendInfos.reduce((sum, { collateralToken }) => sum + collateralToken.valueUSD, 0)
    const borrowBalance = formatLendInfos.reduce((sum, { borrowToken }) => sum + borrowToken.valueUSD, 0)

    return {
      collateralTokens: formatLendInfos
        .map(({ collateralToken }) => collateralToken)
        .filter(({ value }) => value !== 0),
      borrowTokens: formatLendInfos.map(({ borrowToken }) => borrowToken).filter(({ value }) => value !== 0),
      supplyBalance,
      borrowBalance
    }
  } catch (error) {
    console.log(lendContract, error)
    return {
      collateralTokens: [],
      borrowBalance: 0,
      borrowTokens: [],
      supplyBalance: 0
    }
  }
}
